import { defaultIconColor } from '../constants';
import { SVGComponentPropsType } from 'assets/types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <g stroke={color} strokeWidth="2" fill="none" fillRule="evenodd">
      <path d="M4.99 19.51l4.95-4.95M13.475 3.954l-.707 3.536-2.829 2.828-3.535.707 7.07 7.071.708-3.535 2.828-2.829 3.536-.707z" />
    </g>
  </svg>
);
